export const ProcessingStatusEnum = Object.freeze({
    Duplicate: "Duplicate",
    InvoiceCreated: "InvoiceCreated",
    OCRProcessed: "OCRProcessed",
    Received: "Received",
    Rejected: "Rejected",
    UnderReview: "UnderReview",
    FailedInvoiceValidation: "FailedInvoiceValidation",
    OnHold: "OnHold"
});

export const AttachmentType = Object.freeze({
    InvoiceHdr: "InvoiceHdr",
    ReceivedDocument: "ReceivedDocument",
    EmailValidationQueue: "EmailValidationQueue",
    SupportingDocument: "SupportingDocument",
    ReceivedAttachment: "ReceivedAttachment"
});

export const ProcessingStatusShortCodeEnum = Object.freeze({
    Duplicate: "DP",
    InvoiceCreated: "IC",
    OCRProcessed: "OP",
    Received: "RV",
    Rejected: "RJ",
    UnderReview: "UR",
    FailedInvoiceValidation: "FV",
    AwaitingReview: "AV",
    OnHold: "OH"
});

export const ProcessingStatusColorsEnum = {
    InvoiceCreated: "#5FC66A",
    OCRProcessed: "#3399FF",
    Rejected: "#FF6666",
    FailedInvoiceValidation: "#ff661a",
    Received: "#008080",
    Duplicate: "#FFD700",
    UnderReview: "#FFA500",
    OnHold: "#FFB347",
    AwaitingReview: "#077E8C",
};

export const AttachmentProcessingStatusColorsEnum = {
    created: "#5FC66A",
    notSupported: "#FF6666",
    duplicate: "#FFD700",
};

export const EmailStatusColors = {
    forReview: "#ffd900",
    inbox: "#B0C4DE",
    processed: "#5FC66A",
    reviewedIgnore: "#ff8080",
};

export const ProcessingStatusCollections = {
    AllInvoices:[],
    ToBeProcessed: ["AwaitingReview", "OCRProcessed"]
};